/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForOrphanedCloudMonitoringAlert extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForOrphanedCloudMonitoringAlert");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForOrphanedCloudMonitoringAlert.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForOrphanedCloudMonitoringAlert>): BackgroundJobPayloadForOrphanedCloudMonitoringAlert {
        let obj = Object.assign(new BackgroundJobPayloadForOrphanedCloudMonitoringAlert(), model);
        BackgroundJobPayloadForOrphanedCloudMonitoringAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForOrphanedCloudMonitoringAlert>): BackgroundJobPayloadForOrphanedCloudMonitoringAlert {
        if (!model) return null;
        return BackgroundJobPayloadForOrphanedCloudMonitoringAlert.newInstance(<BackgroundJobPayloadForOrphanedCloudMonitoringAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForOrphanedCloudMonitoringAlert) {
        if (!obj) return;

        models.BackgroundJobPayloadForOrphanedCloudMonitoringAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForOrphanedCloudMonitoringAlert): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForOrphanedCloudMonitoringAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * identifier of the resource
     */
    inventory_id: string;

}
